import hexToRgb from './hexToRgb';

const hexToRGBA = (
    hex: string,
    alpha: number,
    fallback = `rgba(57, 83, 164, ${alpha})`,
): string => {
    const rgb = hexToRgb(hex);
    if (!rgb) return fallback;

    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
};

export default hexToRGBA;
